/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import ReactHoverObserver from 'react-hover-observer';

import ReactPlayer from 'react-player';
// import HTMLEllipsis from 'react-lines-ellipsis/lib/html'
import axios from 'axios';

import moment from 'moment';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from 'react-confirm-alert';         //알럿창(alert confirm)

//import { Modal } from 'react-responsive-modal';
// import Modal from 'react-modal';
// import Items from '../pages/Items'
import Tooltip from '@material-ui/core/Tooltip';
import parse from 'html-react-parser';
import { Base64 } from 'js-base64';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

class ContentItemVod extends Component {
  state = {
    mouseOn: false,
    showItem: false,
    wishFlag: this.props.childProps.wishFlag
      ? this.props.childProps.wishFlag
      : 0,
    playIcon: false,
  };
  path = '';
  componentDidMount = () => {
    const { history } = this.props;
    this._getWindowSize();
    window.addEventListener('resize', this._getWindowSize);

    this.path = history.location.pathname;
  };
  componentWillUnmount = () => {
    window.removeEventListener('resize', this._getWindowSize);
  };
  _getWindowSize = () => {
    const { itemSize } = this.props.childProps;
    ////console.log(window.innerWidth)
    //const hSize = (window.innerWidth-18) * (322/181)
    ////console.log('hSize')
    ////console.log(hSize)

    // 282 * 407  493 * 468

    const wSize =
      itemSize === 'small'
        ? parseInt(window.innerWidth - 60) / parseFloat(7.5)
        : parseInt(window.innerWidth - 18) / parseFloat(7.5);
    const wSizeOver =
      itemSize === 'small'
        ? parseInt(window.innerWidth - 60) / parseFloat(4.5)
        : parseInt(window.innerWidth - 18) / parseFloat(4.5);
    const hSize = wSizeOver * (287 / 493);
    const hSize1 = wSizeOver * (282 / 350);
    // const hSizeOrver = wSizeOver * (278/493)

    const fSize =
      itemSize === 'small'
        ? parseInt(window.innerWidth - 60) / parseFloat(120)
        : parseInt(window.innerWidth - 18) / parseFloat(120);
    const fSizeSmail =
      itemSize === 'small'
        ? parseInt(window.innerWidth - 60) / parseFloat(160)
        : parseInt(window.innerWidth - 18) / parseFloat(160);
    //console.log(window.innerWidth-18)
    ////console.log(wSize)
    //493 * 287 도영상
    this.setState({
      wSize: wSize, //wSize > 282 ? 282 : wSize
      wSizeOver: wSizeOver, // wSizeOver > 489 ? 489 : wSizeOver
      hSize: hSize,
      hSize1: hSize1,
      fSize: fSize > 16 ? 16 : fSize,
      fSizeSmail: fSizeSmail > 12 ? 12 : fSizeSmail,
    });
  };

  _goItem = (contentSerial) => {
    const { history } = this.props;

    history.push('/items/' + contentSerial);
  };

  _onToggelMouseOn = (e) => {
    ////console.log('aaaa')
    e.stopPropagation();
    //setTimeout(() => {
    this.setState({
      mouseOn: true,
    });
    //}, 700)
  };
  _onToggelMouseOut = (e) => {
    ////console.log('bbb')
    e.stopPropagation();
    this.setState({
      mouseOn: false,
    });
  };
  _timeToMs = (time) => {
    const tt = time.split(':');
    const sec =
      parseInt(tt[0]) * 3600 + parseInt(tt[1]) * 60 + parseInt(tt[2]) * 1;
    return sec;
    ////console.log(sec)
  };
  _moreItem = () => {
    const { history, setContentSerial } = this.props;
    const { contentSerial } = this.props.childProps;
    //console.log(contentSerial)
    //history.push('/items/' + contentSerial)
    if (this.path === '/live') {
      if (this.props.contentSerial > 0) {
        //console.log('삭제 후 이동')
        setContentSerial(0);

        setTimeout(() => {
          setContentSerial(contentSerial);
        }, 300);
      } else {
        //console.log('이동')
        setContentSerial(contentSerial);
      }
    } else {
      if (this.props.contentSerial > 0) {
        //console.log('삭제 후 이동')
        setContentSerial(0);

        setTimeout(() => {
          history.push('/items/' + contentSerial);
        }, 300);
      } else {
        //console.log('이동')
        history.push('/items/' + contentSerial);
      }
    }
    /*
        if(this.props.contentSerial > 0) {
            setContentSerial(0)
            setTimeout(()=> {
                setContentSerial(contentSerial)
            }, 500)
        } else {
            setContentSerial(contentSerial)
        }
        */
  };
  _onCloseItem = () => {
    this.setState({
      showItem: false,
    });
  };
  _onPlay = async (e) => {
    const { history, loginId, setPlayUrl, setContentSerial, aParam } =
      this.props;
    const { contentPartSerial, contentSerial } = this.props.childProps;

    let target;
    if (e) {
      target = e.currentTarget.className;
      e.stopPropagation();
    } else {
      target = 'list_img_play';
    }

    if (
      target === 'list_img_bg' ||
      target === 'list_text_group' ||
      target === 'list_img_more'
    ) {
      if (this.path === '/live') {
        if (this.props.contentSerial > 0) {
          //console.log('삭제 후 이동')
          setContentSerial(0);

          setTimeout(() => {
            setContentSerial(contentSerial);
          }, 300);
        } else {
          //console.log('이동')
          setContentSerial(contentSerial);
        }
      } else {
        if (this.props.contentSerial > 0) {
          //console.log('삭제 후 이동')
          setContentSerial(0);

          setTimeout(() => {
            history.push('/items/' + contentSerial);
          }, 300);
        } else {
          //console.log('이동')
          history.push('/items/' + contentSerial);
        }
      }
    } else if (target === 'list_img_play' || target === 'list_title') {
      if (loginId === '' || loginId === undefined || loginId === null) {
        toast.warn('로그인후 관람이 가능합니다.');
        history.push('/login');
        return false;
      } else {
        if (
          contentPartSerial === undefined ||
          contentPartSerial === null ||
          contentPartSerial === ''
        ) {
          toast.warn('파라메터가 누락되었습니다.');
        } else {
          const result = await this._onGetSubPartSerialApi();

          const intReturn = result.data[0].intReturn;
          const subData = result.data[0].listData;

          if (intReturn === 0) {
            const subPartSerial2 = subData[0].subPartSerial2;
            const subPartSerial3 = subData[0].subPartSerial3;
            const part = subData[0].part;

            this.setState({
              subData,
            });
            const date = new Date();
            const timeStemp = moment(date)
              .add(10, 'minutes')
              .format('YYYYMMDDHHmmss');
            //let param = this.encode(timeStemp)

            //let crypParam = timeStemp + '|aniplus|' + subPartSerial2 + '/' + loginId
            let crypParam =
              timeStemp +
              '|was|' +
              subPartSerial2 +
              '/' +
              loginId +
              '@' +
              aParam;
            const base64Data = await this._getBase64Encode(crypParam);
            crypParam = base64Data.data.codeString;

            let urlEncode =
              contentPartSerial +
              '|' +
              subPartSerial2 +
              '|' +
              subPartSerial3 +
              '|' +
              part;
            const base64Data1 = await this._getBase64Encode(urlEncode);
            urlEncode = base64Data1.data.codeString;

            const result = await this._onPlayApi(subPartSerial2, crypParam);

            const intReturn = result.data[0].intReturn;
            if (result) {
              //console.log(intReturn)
              if (intReturn === 0 || intReturn === 10) {
                //onCloseModal()

                setPlayUrl(urlEncode);
                //history.push('/player/?u=' + urlEncode)
              } else if (intReturn === -7 || intReturn === -1) {
                alert('서비스 중인 콘텐츠가 아닙니다.');
              } else if (intReturn === -4 || intReturn === -5) {
                //alert('이용권 또는 포인트 구매 후 관람이 가능합니다.')
                toast.warn('이용권 또는 포인트 충전후 관람이 가능합니다');
              } else if (intReturn === -2) {
                alert('19세 미만은 관람이 불가한 작품입니다.');
              } else if (intReturn === -3) {
                //포인트 결제창 뛰울것
                this._onShowModal('vod');
              } else {
                // alert("오류가 발생했습니다.");
              }
            }
          } else {
            toast.error('재생 정보가 존재하지 않습니다.');
          }
        }
      }
    }
    //console.log('play')
  };
  _onGetSubPartSerialApi = () => {
    const { apiUrl } = this.props;
    const { contentPartSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/getSubPartSerial', {
        params: {
          contentPartSerial: contentPartSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };

  _onPlayApi = (subPartSerial, crypParam) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');
    let token = new Date();
    token = moment(token).format('YYYYMMDDhhmmss');
    token = Base64.encode(token);

    return axios
      .post(
        apiUrl + '/vodUrl',
        {
          params: {
            userid: loginId,
            authId: authId,
            subPartSerial: subPartSerial,
            //param: param,
            crypParam: crypParam,
            token: token,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onPlay();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _toggleWish = async () => {
    const { onInit } = this.props.childProps;
    const { loginId, history } = this.props;
    // const { wishFlag } = this.state;

    //console.log(contentSerial, wishFlag)

    if (loginId === '' || loginId === null || loginId === undefined) {
      toast.warn('로그인 후 이용이 가능합니다');
      history.push('/login');
    } else {
      const result = await this._toggleWishApi();
      const intReturn = result.data[0].intReturn; // 0 삭제됨 100 추가됨

      this.setState({
        wishFlag: intReturn,
      });
      //console.log(intReturn)
      if (intReturn === 0) {
        if (onInit) {
          setTimeout(() => {
            onInit(1);
          }, 700);
        }
      }
    }
  };
  _toggleWishApi = () => {
    const { apiUrl, loginId } = this.props;
    const { contentSerial } = this.props.childProps;

    return axios
      .post(apiUrl + '/wishToggle', {
        params: {
          userid: loginId,
          contentSerial: contentSerial,
        },
      })
      .then((response) => response)
      .catch((error) => {
        toast.error('오류가 발생했습니다.');
        //alert('오류가 발생했습니다.')
      });
  };
  _togglePlayOn = () => {
    const { playIcon } = this.state;
    this.setState({
      playIcon: !playIcon,
    });
  };
  _getBase64Encode = (codeString) => {
    const { aspUrl, pkg, loginId } = this.props;
    return axios(
      aspUrl +
        '/base64encode_wd.asp?codeString=' +
        codeString +
        '&p=' +
        pkg +
        '&i=' +
        loginId
    )
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _getBase64Decode = (codeString) => {
    const { aspUrl } = this.props;
    //console.log(aspUrl + '/base64decode.asp?codeString=' + codeString)
    return axios(aspUrl + '/base64decode.asp?codeString=' + codeString)
      .then((response) => response)
      .catch((error) => {
        //console.log('error...')
      });
  };
  _onHoverChange = (isHovering) => {
    const { num, onEndItemSlide } = this.props.childProps;
    if (onEndItemSlide) {
      onEndItemSlide(num, isHovering.isHovering);
    }
  };
  render() {
    // const { loginId } = this.props;
    const { wSize, wSizeOver, hSize, hSize1, hSizeOrver, wishFlag, playIcon } =
      this.state;
    const { imgUrl, serviceEndDate } = this.props;
    const {
      title,
      genreName,
      img,
      overImg,
      restrictionCode,
      opening,
      director,
      contentSysnopsis,
      dRank,
      refer,
      subTitle,
      weekNo,
      weekTime,
      itemSize,
      cashOnly,
    } = this.props.childProps;
    // const regex = /<p>/ig;
    let result = contentSysnopsis.replace(/(br)/gi, '');
    result = result.replace(/(< \/>)/gi, '');
    //const result = contentSysnopsis//.replace(regex, '<br/>');
    ////console.log(dRank)
    //const synopsis = "<p>" + contentSysnopsis + "</p>"
    ////console.log(wishFlag)
    // const customStyles = {
    //     content : {
    //       top: 150,
    //       backgroundColor: 'black'

    //     }
    //   };
    return (
      <Fragment>
        <ReactHoverObserver
          hoverDelayInMs={300}
          hoverOffDelayInMs={300}
          onHoverChanged={this._onHoverChange}
        >
          {({ isHovering }) => (
            <div
              className={isHovering ? 'list_paly2_on div_li' : 'div_li'}
              style={
                isHovering
                  ? isMobile
                    ? null
                    : {
                        transition: 'all ease 0.5s',
                        width: wSizeOver,
                        textAlign: 'center',
                        transformOrigin: 'center center',
                        display: 'inline-block',
                      }
                  : {
                      transition: 'all ease 0.4s',
                      width: wSize,
                      textAlign: 'center',
                      transformOrigin: 'center center',
                      display: 'inline-block',
                    }
              }
            >
              {refer === 'sametime' ||
              refer === 'search' ||
              refer === 'tagSearch' ? null : isHovering ? null : (
                <em className={dRank <= 3 ? 'em_on' : null}>{dRank}</em>
              )}

              {isHovering ? (
                isMobile ? null : (
                  <Tooltip title="찜하기">
                    <div className="list_img_add">
                      <span
                        onClick={this._toggleWish}
                        style={
                          parseInt(wishFlag) > 0
                            ? {
                                background:
                                  'url(/img/add_on.png) no-repeat center center',
                              }
                            : null
                        }
                      >
                        add
                      </span>
                    </div>
                  </Tooltip>
                )
              ) : null}
              <div
                className="list_img_bg"
                style={{ cursor: 'pointer' }}
                onClick={this._onPlay}
              >
                {isHovering ? (
                  isMobile ||
                  moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                    serviceEndDate ? null : (
                    <Tooltip title="관람하기">
                      <div
                        className="list_img_play"
                        onMouseEnter={this._togglePlayOn}
                        onMouseLeave={this._togglePlayOn}
                        onClick={this._onPlay}
                      >
                        {playIcon ? (
                          <img src={imgUrl + '/img/play2.png'} />
                        ) : (
                          <img src={imgUrl + '/img/play2_off.png'} />
                        )}
                      </div>
                    </Tooltip>
                  )
                ) : null}

                {opening === null || opening === '' || opening === undefined ? (
                  <Fragment>
                    <img
                      src={isHovering ? overImg : img}
                      style={
                        isHovering
                          ? {
                              width: wSizeOver,
                              height:
                                hSizeOrver /*, transitionProperty: 'width', transitionDuration: '1s'*/,
                            }
                          : {
                              width: wSize,
                              height:
                                hSize1 /*transitionProperty: 'width', transitionDuration: '4s'*/,
                            }
                      }
                    />
                    {isHovering ? (
                      <Fragment>
                        <div className="list_title" onClick={this._onPlay}>
                          {subTitle}
                          <br />
                          바로보기
                        </div>
                        <div className="list_bg1"></div>
                      </Fragment>
                    ) : null}
                  </Fragment>
                ) : isHovering ? (
                  isMobile ? (
                    <img
                      src={img}
                      style={{
                        width: wSize,
                        height:
                          hSize1 /*transitionProperty: 'width', transitionDuration: '4s'*/,
                      }}
                    />
                  ) : (
                    <Fragment>
                      <ReactPlayer
                        url={'https://jjmp4.ofscdn.com' + opening}
                        //className='bg_img'
                        playing={true}
                        //url={playUrl}
                        volume={0.5}
                        muted={true}
                        //onReady={this._onReady}
                        //onEnded={this._onEnded}
                        //style={{width: wSize, height: hSize}}
                        width={wSizeOver - 20}
                        height={hSize}
                      />
                      <div className="list_title" onClick={this._onPlay}>
                        {subTitle}
                        <br />
                        바로보기
                      </div>
                      <div className="list_bg1"></div>
                    </Fragment>
                  )
                ) : (
                  <Fragment>
                    <img
                      src={img}
                      style={
                        isHovering
                          ? {
                              width: wSizeOver,
                              height:
                                hSizeOrver /*transitionProperty: 'width', transitionDuration: '4s'*/,
                            }
                          : {
                              width: wSize,
                              height:
                                hSize1 /*transitionProperty: 'width', transitionDuration: '4s'*/,
                            }
                      }
                    />
                    {cashOnly > 0 && cashOnly !== undefined ? (
                      <div
                        style={{
                          position: 'absolute',
                          width: 70,
                          height: 22,
                          zIndex: 300,
                          bottom: 10,
                          left: 10,
                        }}
                      >
                        <img
                          src={imgUrl + '/img/bg_won.png'}
                          style={{ width: 70, height: 22 }}
                        />
                      </div>
                    ) : null}
                  </Fragment>
                )}
              </div>
              {isHovering ? (
                isMobile ? (
                  <Fragment>
                    <p
                    // style={{
                    //   paddingBottom:
                    //     refer === 'search' || refer === 'tagSearch' ? 15 : 0,
                    //   whiteSpace: 'normal',
                    //   overflowWrap: 'break-word',
                    // }}
                    >
                      {title}
                    </p>
                    {weekTime === '' ? null : (
                      <Fragment>
                        <p className="genre">
                          <span>{genreName}</span>
                          <span>{restrictionCode}세 관람</span>
                        </p>
                        {itemSize === 'small' ? (
                          moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                          serviceEndDate ? null : (
                            <p className="time">
                              <span>LIVE</span>
                              매주(
                              {weekNo === 1
                                ? '월'
                                : weekNo === 2
                                ? '화'
                                : weekNo === 3
                                ? '수'
                                : weekNo === 4
                                ? '목'
                                : weekNo === 5
                                ? '금'
                                : weekNo === 6
                                ? '토'
                                : weekNo === 7
                                ? '일'
                                : null}
                              ) {weekTime}
                            </p>
                          )
                        ) : null}
                      </Fragment>
                    )}
                  </Fragment>
                ) : (
                  <div
                    className="list_text_group"
                    style={{ cursor: 'pointer' }}
                    onClick={this._onPlay}
                  >
                    <Tooltip title="상세보기">
                      <div className="list_img_more" onClick={this._onPlay}>
                        <a style={{ cursor: 'pointer' }}>더보기</a>
                      </div>
                    </Tooltip>
                    <div
                      className="title_name"
                      style={{
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                      }}
                    >
                      {title}{' '}
                      <span /*style={{fontSize: fSizeSmail}}*/>
                        {restrictionCode}세&nbsp;&nbsp;|&nbsp;&nbsp;{genreName}
                        &nbsp;&nbsp;|&nbsp;&nbsp;{director}
                      </span>
                    </div>
                    <p
                      style={{
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                      }}
                      onClick={this._moreItem}
                    >
                      {parse(result.substr(0, 60))}
                      {/*
                                    <HTMLEllipsis
                                        unsafeHTML={`<p style="font-size: ${fSizeSmail}px">${contentSysnopsis}</p>`}
                                        maxLine='3'
                                        ellipsis='...'
                                        basedOn='letters'
                                    />
                                    */}
                    </p>
                  </div>
                )
              ) : (
                <Fragment>
                  <p
                  // style={{
                  //   paddingBottom:
                  //     refer === 'search' || refer === 'tagSearch' ? 15 : 0,
                  //   whiteSpace: 'normal',
                  //   overflowWrap: 'break-word',
                  // }}
                  >
                    {title}
                  </p>
                  {weekTime === '' ? null : isMobile ? null : (
                    <Fragment>
                      <p className="genre">
                        <span>{genreName}</span>
                        <span>{restrictionCode}세 관람</span>
                      </p>
                      {itemSize === 'small' ? (
                        moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
                        serviceEndDate ? null : (
                          <p className="time">
                            <span>LIVE</span>
                            매주(
                            {weekNo === 1
                              ? '월'
                              : weekNo === 2
                              ? '화'
                              : weekNo === 3
                              ? '수'
                              : weekNo === 4
                              ? '목'
                              : weekNo === 5
                              ? '금'
                              : weekNo === 6
                              ? '토'
                              : weekNo === 7
                              ? '일'
                              : null}
                            ) {weekTime}
                          </p>
                        )
                      ) : null}
                    </Fragment>
                  )}
                </Fragment>
              )}
            </div>
          )}
        </ReactHoverObserver>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}

        {/*
                <div onMouseEnter={this._onMouseToggle} onMouseLeave={this._onMouseToggle} onClick={()=>this._goItem(contentSerial)}>
                    <img src={img} draggable="false" alt="" style={onMouseOver ? styles.onZoom : styles.onNomal } />
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(ContentItemVod));
